import {
    Button,
    CircularProgress,
    TextField,
    MenuItem, FormLabel, RadioGroup, FormControlLabel, Radio
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormEditSmmDomain = ({ data, setData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();
    for (let key in data) {
      if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.SmmDomain.Edit +"/"+ id,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/SmmDomains");
      }
    } catch (error) {
      console.error("Update error:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
          <TextField
              fullWidth
              margin="normal"
              label="Domain"
              name="domain"
              required
              autoComplete="off"
              value={data.domain}
              onChange={handleInputChange}
              variant="outlined"
              helperText={ "Add the domain url without http:// or https://"}
          />

          <TextField
              fullWidth
              margin="normal"
              label="Description"
              name="description"
              required
              autoComplete="off"
              value={data.description}
              onChange={handleInputChange}
              variant="outlined"
              helperText={" "}
          />

          <TextField
              fullWidth
              margin="normal"
              label="Price"
              name="price"
              required
              autoComplete="off"
              value={data.price}
              onChange={handleInputChange}
              variant="outlined"
          />
            <div className="w-full flex items-center justify-start gap-x-3">
                <FormLabel sx={{ fontWeight: "bold" }} component="legend">
                    active :
                </FormLabel>
                <RadioGroup
                    name="is_active"
                    value={data?.is_active}
                    onChange={handleInputChange}
                    row
                >
                    <FormControlLabel value="1" control={<Radio />} label="Yes" />
                    <FormControlLabel value="0" control={<Radio />} label="No" />
                </RadioGroup>
            </div>
            {/*<div className="w-full flex items-center justify-start gap-x-3">*/}
            {/*    <FormLabel sx={{ fontWeight: "bold" }} component="legend">*/}
            {/*        Sold :*/}
            {/*    </FormLabel>*/}
            {/*    <RadioGroup*/}
            {/*        name="is_sold"*/}
            {/*        value={data?.is_sold}*/}
            {/*        onChange={handleInputChange}*/}
            {/*        row*/}
            {/*    >*/}
            {/*        <FormControlLabel value="1" control={<Radio />} label="Yes" />*/}
            {/*        <FormControlLabel value="0" control={<Radio />} label="No" />*/}
            {/*    </RadioGroup>*/}
            {/*</div>*/}
        </div>

        <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={isLoadingSubmit}
            color="primary"
            sx={{
              display: isLoadingSubmit ? "flex" : "block",
              marginTop: 2,
              width: "20%",
              marginX: "auto",
              fontWeight: "bold",
              justifyContent: "center",
            }}
        >
          {isLoadingSubmit ? (
              <CircularProgress size={24} color="inherit" />
          ) : (
              "Update Contact"
          )}
        </Button>
      </form>
  );
};